import { Navigate, useLocation } from "react-router-dom";
import { useMember } from "@/contexts/MemberContext";

export function RegistrationGate({ children }) {
  const { member } = useMember();
  const location = useLocation();
  if (!member) {
    return <Navigate to="/register" replace state={{ from: location.pathname }} />;
  }
  return children;
}
